import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import {
  createFindPasswordStore,
  FindPasswordState,
  FindPasswordStoreApi,
  selectIsPossibleReset,
  selectResetBody,
} from '../stores/createFindPasswordStore';

const FindPasswordStoreContext = createContext<FindPasswordStoreApi | null>(null);

export function useFindPasswordStore<U>(selector: (s: FindPasswordState) => U): U {
  const api = useContext(FindPasswordStoreContext);
  if (!api) {
    throw new Error('useFindPasswordStore must be used within FindPasswordProvider');
  }
  return useStore(api, selector);
}

export { selectIsPossibleReset, selectResetBody };

export const FindPasswordProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [store] = useState(() => createFindPasswordStore());
  return (
    <FindPasswordStoreContext.Provider value={store}>
      {children}
    </FindPasswordStoreContext.Provider>
  );
};
